(() => {
  const keys = { company: 'Фирма', mol: 'МОЛ', eik: 'ЕИК', vat: 'ДДС номер', address: 'Адрес за фактуриране' };
  const root = window.Shopify?.routes?.root || '/';
  let state, queue = Promise.resolve(), timer, busy = false;
  let previewFrame;
  const previewObserver = new ResizeObserver(updatePreviewInset);
  function updatePreviewInset() {
    const frame = document.getElementById('PBarNextFrame');
    if (frame && frame !== previewFrame) {
      if (previewFrame) previewObserver.unobserve(previewFrame);
      previewFrame = frame;
      previewObserver.observe(frame);
    }
    const rect = frame?.getBoundingClientRect();
    const inset = rect && rect.width > 0 && rect.height > 0 ? 64 : 0;
    document.documentElement.style.setProperty('--pmu-preview-inset', inset + 'px');
  }
  window.addEventListener('resize', updatePreviewInset);
  const panels = () => [...document.querySelectorAll('[data-pmu-invoice]')];
  const read = panel => {
    const result = { 'Желая фактура': panel.querySelector('[data-invoice-check]').checked ? 'Да' : 'Не' };
    for (const [id, key] of Object.entries(keys)) result[key] = panel.querySelector('[data-invoice-field="' + id + '"]').value;
    return result;
  };
  const error = message => panels().forEach(p => p.querySelector('[data-invoice-error]').textContent = message);
  function sync() {
    const all = panels();
    if (!state && all.length) state = read(all[0]);
    if (!state) return;
    const requested = state['Желая фактура'] === 'Да';
    all.forEach(panel => {
      const check = panel.querySelector('[data-invoice-check]');
      check.checked = requested;
      check.disabled = busy;
      check.setAttribute('aria-expanded', String(requested));
      panel.classList.toggle('is-open', requested);
      panel.querySelector('.pmu-invoice__reveal').inert = !requested;
      for (const [id, key] of Object.entries(keys)) {
        const input = panel.querySelector('[data-invoice-field="' + id + '"]');
        if (input.value !== state[key]) input.value = state[key] || '';
        input.disabled = !requested || busy;
        input.required = requested && id !== 'vat';
      }
    });
  }
  function save(attributes) {
    const operation = queue.catch(() => {}).then(async () => {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) throw new Error('save');
      const cart = await response.json();
      for (const [key, value] of Object.entries(attributes)) if ((cart.attributes?.[key] || '') !== value) throw new Error('verify');
      return cart;
    });
    queue = operation;
    return operation;
  }
  let invoiceScrollRevision = 0;
  async function revealInvoiceInDrawer(panel) {
    const revision = ++invoiceScrollRevision;
    const drawer = panel.closest('cart-drawer');
    const scroller = panel.closest('cart-drawer-items');
    if (!drawer || !scroller) return;
    await new Promise(resolve => requestAnimationFrame(resolve));
    const reveal = panel.querySelector('.pmu-invoice__reveal');
    await Promise.all(reveal.getAnimations().map(animation => animation.finished.catch(() => {})));
    await new Promise(resolve => requestAnimationFrame(resolve));
    if (revision !== invoiceScrollRevision || !panel.isConnected || !drawer.classList.contains('active') || !panel.querySelector('[data-invoice-check]').checked) return;
    const first = panel.querySelector('[data-invoice-field="company"]');
    const label = panel.querySelector('label[for="' + first.id + '"]') || first;
    const target = scroller.scrollTop + label.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 8;
    scroller.scrollTo({
      top: Math.max(0, Math.min(target, scroller.scrollHeight - scroller.clientHeight)),
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  }
  function capture(event) {
    const panel = event.target.closest?.('[data-pmu-invoice]');
    if (!panel || busy) return;
    event.stopPropagation();
    const opening = event.target.matches('[data-invoice-check]') && event.target.checked && state?.['Желая фактура'] !== 'Да';
    const closing = event.target.matches('[data-invoice-check]') && !event.target.checked && state?.['Желая фактура'] === 'Да';
    state = read(panel);
    if (event.target.setCustomValidity) event.target.setCustomValidity('');
    sync();
    if (opening) revealInvoiceInDrawer(panel);
    if (closing) {
      invoiceScrollRevision++;
      const scroller = panel.closest('cart-drawer-items');
      if (scroller) scroller.scrollTo({ top: scroller.scrollTop, behavior: 'instant' });
    }
    error('');
    clearTimeout(timer);
    const attributes = { ...state };
    if (event.type === 'change') save(attributes).catch(() => error('Данните не бяха запазени. Опитайте отново.'));
    else timer = setTimeout(() => save(attributes).catch(() => error('Данните не бяха запазени. Опитайте отново.')), 200);
  }
  async function checkout(source) {
    if (busy) return;
    const panel = source?.closest('[data-pmu-invoice]') || panels().find(p => p.getClientRects().length && !p.closest('cart-drawer:not(.active)'));
    if (!panel) { window.location.assign(root + 'cart'); return; }
    clearTimeout(timer);
    state = read(panel);
    for (const key of Object.values(keys)) state[key] = state[key].trim();
    sync();
    if (state['Желая фактура'] === 'Да') {
      for (const id of Object.keys(keys)) {
        const input = panel.querySelector('[data-invoice-field="' + id + '"]');
        input.setCustomValidity(id !== 'vat' && !input.value.trim() ? 'Моля, попълнете това поле.' : '');
        if (!input.reportValidity()) return;
      }
    }
    busy = true;
    sync();
    error('');
    try {
      await save({ ...state });
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('read');
      const cart = await response.json();
      if (!cart.item_count) throw new Error('empty');
      for (const [key, value] of Object.entries(state)) if ((cart.attributes?.[key] || '') !== value) throw new Error('verify');
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = root + 'cart';
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = 'checkout';
      form.append(input);
      document.body.append(form);
      HTMLFormElement.prototype.submit.call(form);
    } catch {
      busy = false;
      sync();
      error('Не успяхме да запазим данните. Проверете връзката си и опитайте отново.');
    }
  }
  document.addEventListener('input', capture, true);
  document.addEventListener('change', capture, true);
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[name="checkout"], a[href]');
    if (!target) return;
    const url = target.tagName === 'A' ? new URL(target.href, location.href) : null;
    if (target.name !== 'checkout' && !(url?.origin === location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(target);
  }, true);
  document.addEventListener('submit', event => {
    const url = new URL(event.target.action, location.href);
    if (event.submitter?.name !== 'checkout' && !/\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname) && !(['cart','CartDrawer-Form'].includes(event.target.id) && !event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(event.target);
  }, true);
  window.addEventListener('pageshow', () => { busy = false; sync(); });
  new MutationObserver(records => {
    updatePreviewInset();
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-pmu-invoice]') || n.querySelector?.('[data-pmu-invoice]'))))) sync();
  }).observe(document.body, { childList: true, subtree: true });
  sync();
  updatePreviewInset();
})();